<template>
  <div :class="['rk-title', noEdgePadding ? 'no-edge-padding' : null]" @click="$emit('click')">
    <div class="left">
      <slot name="left">{{ $t(title) }}</slot>
    </div>
    <slot name="right">
      <div v-if="$listeners.click" class="right">
        {{ $t(text) }}
        <i class="iconfont icon-gengduo"></i>
      </div>
    </slot>
    <div v-if="!noSplit" class="bottom-line" />
  </div>
</template>

<script>
export default {
  name: 'rk-title',
  props: {
    title: {
      type: String,
      default: '标题'
    },
    text: {
      type: String,
      default: ''
    },
    noSplit: { type: Boolean, default: false },
    noEdgePadding: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.rk-title {
  --rk-title-padding: 9px var(--edge-padding);
  --rk-title-font-size: 16px;
  --rk-title-font-weight: 700;
  --rk-title-font-color: var(--font-color-1);

  position: relative;
  display: flex;
  align-items: center;
  padding: var(--rk-title-padding);
  line-height: 26px;
  font-size: var(--rk-title-font-size);
  font-weight: var(--rk-title-font-weight);
  color: var(--rk-title-font-color);
  &.no-edge-padding {
    --rk-title-padding: 9px 0;
  }
  .left {
    margin-right: auto;
  }
  .right {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    color: var(--font-color-3);
    cursor: pointer;
    .iconfont {
      font-size: 12px;
      font-weight: bold;
    }
  }

  .bottom-line {
    height: 1px;
    width: 100vw;
    background: var(--border-color-1);
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
